import React from 'react';
import { XIcon } from '../../../../SVG';
import { THEME } from '../../../../clearstep/util/Theme';
import PartnerLogo from '../../../../tailwind_clearstep/PartnerLogo/PartnerLogo';
import '../../../utils/Flows';
import { WidgetStateChangeType, WidgetStates } from '../../Widget';
import { getIntialStateIsHidden } from '../../../utils/Params';
// Because this is a single flow, we remove the "Back Button" wrapper to the header text
// Instead, display an x which will take user back to the collapsed greeting message
export var WidgetHeaderContentSingleFlowWithExit = function (props) {
    var _a;
    var setWorkflow = props.setWorkflow, headerText = props.headerText, setWidgetState = props.setWidgetState, mobileState = props.mobileState;
    var customTheme = ((_a = THEME.widgetCustomizations) === null || _a === void 0 ? void 0 : _a.widgetHeaderTheme) || {};
    var initialState = getIntialStateIsHidden(mobileState)
        ? WidgetStates.HIDDEN
        : WidgetStates.COLLAPSED;
    return (React.createElement("div", { className: "ml-5 mr-3 flex w-full justify-between" },
        React.createElement("div", { className: "flex flex-col pb-2.5" },
            React.createElement("div", { className: "flex items-center" },
                React.createElement(PartnerLogo, { customLogoPath: customTheme.logoPath, enableLogoLink: false, imageClassName: "w-20 mb-1.5" })),
            React.createElement("span", { className: "text-xl font-medium leading-none text-primary" }, headerText)),
        React.createElement("div", { className: "mb-1 flex items-end" },
            React.createElement("button", { className: "mb-neg-2 p-4", onClick: function () {
                    setWorkflow(null, WidgetStateChangeType.MANUAL);
                    setWidgetState(initialState, WidgetStateChangeType.MANUAL);
                } },
                React.createElement(XIcon, { stroke: "#9CA3AF" })))));
};
export default WidgetHeaderContentSingleFlowWithExit;
